import { render, staticRenderFns } from "./dp-legend.vue?vue&type=template&id=341abb5c&scoped=true"
import script from "./dp-legend.vue?vue&type=script&lang=js"
export * from "./dp-legend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341abb5c",
  null
  
)

export default component.exports